import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTypedSearchParams } from 'react-router-typesafe-routes';
import type { Props as HeaderConfig } from '@/components/layouts/page-layout/app-header';
import ForwardForm from '@/components/scan-code/forward-form';
import useBatchForward, { type ForwardTarget } from '@/hooks/forward/use-batch-forward';
import { ConversationMessageContentType } from '@/models/conversations/conversation';
import ROUTES from '@/routes';

export default function ShareQrCodeRoute({ navigateBack }: Pick<HeaderConfig, 'navigateBack'>) {
  const [{ code }] = useTypedSearchParams(ROUTES.CONTACT.REQUEST.SCAN.SHARE);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync, isPending: isForwarding } = useBatchForward();

  const handleForward = async (targets: ForwardTarget[], clearSelection: () => void) => {
    if (!code) return;
    if (await mutateAsync({ urls: [{ url: code, type: ConversationMessageContentType.Image }], targets })) {
      navigate(-1);
    } else {
      clearSelection();
    }
  };

  return (
    <ForwardForm
      navigateBack={navigateBack}
      isLoading={isForwarding}
      title={t('personal-info.share-to')}
      onForward={handleForward}
    />
  );
}
